import { GetProjectOutcomeResponseType } from '@frontend/sorghum/interface';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { PROJECT_OUTCOME } from '../apis';

const defaultValue: GetProjectOutcomeResponseType = {
  customersUniqCount: 0,
};
async function getProjectOutcome(): Promise<GetProjectOutcomeResponseType> {
  return axios
    .get(PROJECT_OUTCOME)
    .then((res) => res.data.data)
    .catch((_) => defaultValue);
}
export function useGetProjectOutcome(projectID: string | undefined) {
  return useQuery<GetProjectOutcomeResponseType>({
    queryKey: ['get-project-outcome', { projectID }],
    queryFn: () => {
      if (projectID) {
        return getProjectOutcome();
      } else {
        return defaultValue;
      }
    },
  });
}

export default useGetProjectOutcome;
